// Partner "Genel Bakış" — Yaklaşan / Yapılan Ödemeler (Lidio hakedişleri) gösterim kuralları.
// BE: payments::getMerchantPayouts (flow/get-merchant-payouts). Kalem durumları:
//   blocked   → tahsilattan sonra bloke (serbest bırakılmadı; ~escrowDays gün sonra serbest kalır)
//   released  → serbest bırakıldı, Lidio yatış gününü henüz bildirmedi
//   scheduled → yatış günü belli
//   paid      → yatış günü geldi ("Lidio'ya göre yatırıldı" — banka teyidi değildir)

// Partner Genel Bakış şimdilik GİZLİ (30.09.2026, kullanıcı kararı): false iken menüde ve Yetkilendirme
// matrisinde yok, /merchant-overview anasayfaya yönlenir. Kod ve sunucu ucu yerinde; açmak için true yap.
export const MERCHANT_OVERVIEW_ENABLED = false;

export const PAYOUT_STATUS_META = Object.freeze({
  blocked: { label: "Bloke", variant: "orange" },
  released: { label: "Serbest", variant: "neutral" },
  scheduled: { label: "Planlandı", variant: "blue" },
  paid: { label: "Yatırıldı", variant: "green" },
});

export function getPayoutStatusMeta(status) {
  return PAYOUT_STATUS_META[status] || { label: "-", variant: "neutral" };
}

export function formatPayoutDate(unixSeconds) {
  const ts = Number(unixSeconds);
  if (!Number.isFinite(ts) || ts <= 0) return "-";
  const date = new Date(ts * 1000);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${day}.${month}.${date.getFullYear()}`;
}

// Yaklaşan kalemin "Yatış Tarihi" hücresi: { text, note }.
export function describeUpcomingPayoutDate(item) {
  if (item?.status === "scheduled" && Number(item?.paybackDate) > 0) {
    return { text: formatPayoutDate(item.paybackDate), note: "" };
  }
  if (item?.status === "blocked") {
    const release = formatPayoutDate(item?.releaseDate);
    return {
      text: "Belirlenmedi",
      note: release !== "-" ? `${release} tarihinde serbest kalır (tahmini)` : "Serbest bırakılınca belirlenir",
    };
  }
  return { text: "Belirlenmedi", note: "Yatış tarihini ödeme kuruluşu bildirecek" };
}

// Sıralama anahtarı: yatış günü, yoksa (tahmini) serbest kalma günü.
export function upcomingSortDate(item) {
  return Number(item?.paybackDate) || Number(item?.releaseDate) || 0;
}

// Sunucu yanıtını güvenli biçime getirir (eksik alan / hatalı tip ekranı düşürmesin).
export function normalizePayoutsResult(result) {
  const r = result && typeof result === "object" && !Array.isArray(result) ? result : {};
  const s = r.summary && typeof r.summary === "object" ? r.summary : {};
  const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);
  const list = (v) => (Array.isArray(v) ? v.filter((x) => x && typeof x === "object") : []);
  return {
    summary: {
      upcomingTotal: num(s.upcomingTotal),
      upcomingCount: num(s.upcomingCount),
      blockedTotal: num(s.blockedTotal),
      blockedCount: num(s.blockedCount),
      nextPayoutDate: Number(s.nextPayoutDate) > 0 ? Number(s.nextPayoutDate) : null,
      nextPayoutAmount: num(s.nextPayoutAmount),
      paidTotal: num(s.paidTotal),
      paidCount: num(s.paidCount),
      paidThisMonth: num(s.paidThisMonth),
    },
    upcoming: list(r.upcoming).map((item) => ({ ...item, sortDate: upcomingSortDate(item) })),
    paid: list(r.paid),
    escrowDays: num(r.escrowDays) || 3,
    truncated: Boolean(r.truncated),
  };
}
